export class PricingService {
    cache;
    constructor(cache) {
        this.cache = cache;
    }
}
//# sourceMappingURL=service.js.map